import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Set System settings at the very begining before importing the application
 */
import '@config/system/load-from-current-script';
import '@config/index';
import store, { initializeStore } from '@data/stores/Store';
import AppInner from './AppInner';
import './ImmsersiveExperienceApp.scss';
const storeLoader = initializeStore();
const ImmersiveExperienceApp = ({ disableCssTitleReset = false, hideCustomFooter = false, hideCustomHeader = false, hidePropertyInfo = false, mode = 'standard', }) => {
    store.environment.setImmersiveExperienceSettings({
        disableCssTitleReset,
        hideCustomFooter,
        hideCustomHeader,
        hidePropertyInfo,
        mode,
    });
    return _jsx(AppInner, { storeLoader: storeLoader });
};
export default ImmersiveExperienceApp;
